import { render, staticRenderFns } from "./TextVerticalIcon.vue?vue&type=template&id=2da32c8e"
import script from "./TextVerticalIcon.vue?vue&type=script&lang=ts"
export * from "./TextVerticalIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da32c8e')) {
      api.createRecord('2da32c8e', component.options)
    } else {
      api.reload('2da32c8e', component.options)
    }
    module.hot.accept("./TextVerticalIcon.vue?vue&type=template&id=2da32c8e", function () {
      api.rerender('2da32c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/TextVerticalIcon.vue"
export default component.exports